import * as types from "./mutation_types";
import axios from "axios";
import {CSRF_TOKEN} from "@/common/csrf_token";

export const reset = ({ commit }) => {
  commit(types.ADHESION_CREATE_RESET);
};

export const create = ({ commit }, values) => {
  axios.defaults.headers.common = {
    "X-CSRFTOKEN": CSRF_TOKEN,
  };
  commit(types.ADHESION_CREATE_SET_ERROR, "");
  commit(types.ADHESION_CREATE_TOGGLE_LOADING);
  axios
    .post("/api/adherents/", values)
    .then(() => {
      commit(types.ADHESION_CREATE_SET_CREATED, true);
      commit(types.ADHESION_CREATE_TOGGLE_LOADING);
    })
    .catch((e) => {
      commit(types.ADHESION_CREATE_TOGGLE_LOADING);
      commit(types.ADHESION_CREATE_SET_ERROR, e.message);
    });
};
